export default "__VITE_ASSET__dd1d012e__"